import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    width: 'auto',
    padding: '0 1rem',
    fontSize: theme.size.sm
  },

  icon: {
    marginRight: '0.5rem'
  },

  spinner: {
    width: '12px !important',
    height: '12px !important',
    color: '#b7b7b7'
  }
}))

export default useStyles
